import React from 'react'
import { PropTypes } from 'prop-types'
import onClickOutside from 'react-onclickoutside'

import ActionLogic from 'components/Util/ActionLogic'

export const ContextMenuContext = React.createContext()

class ContextMenuLogic extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isOpen: (props.initOpen && !props.initOpenDelay) || false,
            openCount: 0,
        }

        if (props.initOpen && props.initOpenDelay > 0) {
            setTimeout(() => {
                this.open()
            }, props.initOpenDelay)
        }
    }

    handleClickOutside = (e) => {
        const { closeOnClickOutside } = this.props
        const { isOpen } = this.state

        if (isOpen && closeOnClickOutside) {
            this.close()
        }
    }

    close = () => {
        this.setState({ isOpen: false })
    }

    open = () => {
        const { openCount } = this.state
        this.setState({ isOpen: true, openCount: openCount + 1 })
    }

    toggle = () => {
        const { isOpen } = this.state
        isOpen ? this.close() : this.open()
    }

    actions = {
        open: this.open,
        close: this.close,
        toggle: this.toggle,
    }

    render () {
        const { isOpen, openCount } = this.state

        return (
            <ActionLogic>
                {(actionLogic) => {
                    const props = {
                        ...actionLogic,
                        actions: this.actions,
                        isOpen: isOpen,
                        openCount: openCount,
                        onClickOutside: this.handleClickOutside,
                    }
                    return (
                        <ContextMenuContext.Provider value={props}>
                            {this.props.children(props)}
                        </ContextMenuContext.Provider>
                    )
                }}
            </ActionLogic>
        )
    }
}

ContextMenuLogic.propTypes = {
    initOpen: PropTypes.bool,
    initOpenDelay: PropTypes.number,
}

ContextMenuLogic.propTypes = {
    closeOnClickOutside: PropTypes.bool,
    children: PropTypes.func.isRequired,
}

export default onClickOutside(ContextMenuLogic)
